export type Verdict = 'real' | 'fake';

/** null = not yet revealed */
export type RevealFlag = Verdict | null;

export interface RealItem {
  id: string;
  /** Readable id used by preview links; stable once assigned. */
  slug?: string;
  verdict: 'real';
  headline: string;
  sourceName: string;
  /** Where REVEAL navigates. Already unwrapped from any google.com/url?q= redirect. */
  sourceUrl: string;
}

/* A fake reveal is a COMPOSED page, not one flat graphic. Alyssa builds it in the app —
   headline, images beneath it, supporting copy — so she never waits on a designer to change
   a word. A finished design can still be used: upload it as the single image and leave the
   text fields empty, and the play view renders it full-bleed instead (see FakeReveal). */
export interface FakeItem {
  id: string;
  /** Readable id used by preview links; stable once assigned. */
  slug?: string;
  verdict: 'fake';
  headline: string;
  /** Absolute URLs, in display order. */
  images: string[];
  body: string;
  footerNote: string;
}

export type RoundItem = RealItem | FakeItem;

export interface Round {
  id: string;
  title: string;
  /* The corner banner belongs to the ROUND, so every fake page in it agrees by construction.
     Empty string = the banner is off for this round. */
  ribbonLabel?: string;
  /** Round-wide headline size. Absent = medium, i.e. exactly as it rendered before. */
  headlineSize?: string;
  /** Show the "Adorian" wordmark on this round's fake pages. */
  showWordmark?: boolean;
  /** Endless Mode only: 'shuffled' randomises per session, 'queue' plays the order as built. */
  playOrder?: 'queue' | 'shuffled';
  items: RoundItem[];
  /** Optional uploaded stamp art. When absent the play view draws the type-only stamp. */
  stampRealUrl?: string | null;
  stampFakeUrl?: string | null;
}

export function isReal(item: RoundItem): item is RealItem {
  return item.verdict === 'real';
}


